import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/services/services-background-cubes.svg")